import React from 'react';

const PlannerSessionSummary = ({ sessionSummary }) => {
  if (!sessionSummary) return null;

  return (
    <div style={{ marginTop: '2rem' }}>
      <h3>Session Summary</h3>
      <pre>{JSON.stringify(sessionSummary, null, 2)}</pre>

      {/* 🔗 Linked Principles */}
      {sessionSummary.principles?.length > 0 && (
        <>
          <h4>🔗 Linked Principles</h4>
          <ul>
            {sessionSummary.principles.map((p) => (
              <li key={p.id}>
                <strong>ID:</strong> {p.id}, <strong>Title:</strong> {p.title}, <strong>Linked At:</strong> {p.linked_at}
              </li>
            ))}
          </ul>
        </>
      )}

      {/* 🎯 Session Goals */}
      {sessionSummary.goals?.length > 0 && (
        <>
          <h4>🎯 Session Goals</h4>
          <ul>
            {sessionSummary.goals.map((g) => (
              <li key={g.id}>
                <strong>ID:</strong> {g.id}, <strong>Description:</strong> {g.description}, <strong>Created:</strong> {g.created_at}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default PlannerSessionSummary;
